import { render, staticRenderFns } from "./CompareIndex.vue?vue&type=template&id=2aad10e8&scoped=true&"
import script from "./CompareIndex.vue?vue&type=script&lang=js&"
export * from "./CompareIndex.vue?vue&type=script&lang=js&"
import style0 from "./CompareIndex.vue?vue&type=style&index=0&id=2aad10e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aad10e8",
  null
  
)

export default component.exports